/**
 * @generated SignedSource<<5f713f9d6bce66b04113c446bafdb0f1>>
 * @relayHash 0550c6bbd591e899e249a8070b81bfd8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f8101949bda55227f7f41d353249b81c60270d2fa5f86056faad76105ef319b9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkforceRoutingDataProviderQuery } from './WorkforceRoutingDataProviderQuery.graphql';

const node: PreloadableConcreteRequest<WorkforceRoutingDataProviderQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f8101949bda55227f7f41d353249b81c60270d2fa5f86056faad76105ef319b9",
    "metadata": {},
    "name": "WorkforceRoutingDataProviderQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
